export type PropertyUnitType = "BUILDING" | "RESIDENTIAL"

export const propertyUnitTypeOptions: Array<{ name: string; value: PropertyUnitType }> = [
  { name: "Gebäudeeinheit", value: "BUILDING" },
  { name: "Wohneinheit", value: "RESIDENTIAL" },
]

export const normalizePropertyUnitType = (value: string | null | undefined): PropertyUnitType =>
  value === "BUILDING" ? "BUILDING" : "RESIDENTIAL"

export const formatPropertyUnitType = (value: string | null | undefined) =>
  normalizePropertyUnitType(value) === "BUILDING" ? "Gebäudeeinheit" : "Wohneinheit"

export const isBuildingPropertyUnit = (unit: { unit_type?: string | null } | null | undefined) =>
  normalizePropertyUnitType(unit?.unit_type) === "BUILDING"
